import React from 'react'
import Link from 'next/link'
import Image from 'next/image'
import { breakpoint } from '../layout/styles'
import Cta from '../styles/Cta'
import ReactHtmlParser from 'react-html-parser'
import { Wrapper } from './InspirationGrid'
import styled, { css } from 'styled-components'

const HeaderBanner = ({ item }: any) => {
  return (
    <Container bg={item.background?.[0]?.background}>
      <ImageContent themePage={item.style === 'theme page'}>
        <Image
          src={`${item.image?.url}?height=990&auto=webp&format=pjpg&quality=75`}
          alt={item.image?.alt || 'Banner Image'}
          layout="fill"
          objectFit= "cover"
          priority
        />
      </ImageContent>

      <Content tagline={item.style === 'tagline'} compact={item.compact_text_spacing}>
        <h2 dangerouslySetInnerHTML={{ __html: item.title }}></h2>
        {item.teaser && (
          <p>
            <b>{ReactHtmlParser(item.teaser)}</b>
          </p>
        )}
        <p>{ReactHtmlParser(item.description)}</p>
        {item.list_items && (
          <ul>
            {item.list_items.map((list_item : string, index: number) =>
              <li key={index}>{list_item}</li>
            )}
          </ul>
        )}
        <div className='cta-container'>
          {item.cta?.href && (
            <Link href={item.cta.href} passHref>
              <Cta href="" light={item.text_style === 'Light'}>
                {ReactHtmlParser(item.cta.title)}
              </Cta>
            </Link>
          )}
          {item.cta2?.href && (
            <Link href={item.cta2.href} passHref>
              <Cta href="" light={item.text_style === 'Light'}>
                {ReactHtmlParser(item.cta2.title)}
              </Cta>
            </Link>
          )}
        </div>
      </Content>
      {item.background?.[0]?.background && (
        <style
          dangerouslySetInnerHTML={{
            __html: `
          @media (min-width: 1152px) { 
            header { 
              background-color: ${item.background?.[0].background} !important 
            }
          }`
          }}
        />
      )}
    </Container>
  )
}

export default HeaderBanner

export const Content = styled.div<any>`
  z-index: 1;
  padding: 48px 0 0 32px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @media ${breakpoint.desktop} {
    max-width: ${(props) => (props.center ? `760px` : props.tagline ? `420px` : `380px`)};
  }
  h2 {
    font-size: 36px;
    line-height: 40px;
    margin-top: 0;
    ${(props) =>
      props.tagline &&
      css`
        font-size: 18px;
        line-height: 20px;
        font-weight: 400;
        margin: 0;
      `}
    
    .orange {
      color: var(--orange);
    }
  }
  p {
    white-space: pre-wrap;
    line-height: 21px;
  }
  b {
    font-size: 18px;
    line-height: 26px;
    ${(props) =>
      props.tagline &&
      css`
        font-size: 36px;
        text-transform: uppercase;
        font-family: GothamMedium, 'Open Sans', sans-serif;
        line-height: 40px;
      `}
  }
  
  ul {
    padding: 0 1rem 1rem;
    
    li {
      margin-top: 0.5rem;
    }
  }
  
  .cta-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    gap: 0.5rem 1.25rem;
    @media screen and (min-width: 1330px){
      width: 110%;
    }
    a {
      margin-bottom: 0;
    }
  }

  // for /faroe-island-salmon page on foodservice
  ${(props) => props.compact && css`
    h2{
      margin-top: 0;
      margin-bottom: 1.5rem;
    }
    p{
      margin-bottom: 1rem;
      margin-top: 0;
    }
    > ul{
      padding-top: 0;
      padding-bottom: 0;
      margin-bottom: 1.5rem;
      margin-top: -0.5rem;
    }
    // in case buttons stack and content is too tall,
    // we want some space below them
    > *:last-child{
      padding-bottom:  1rem;
    }
  `}

`

export const Container = styled.div<any>`
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
  @media screen and ${breakpoint.desktop} {
    margin-top: 0;
    margin-bottom: 0;
    flex-direction: row;
    &:before {
      content: '';
      position: absolute;
      top: -140px;
      left: 0;
      width: 100%;
      height: 900px;
      background: ${(props) => props.bg};
      z-index: 0;
    }
  }
  ${Content} {
    background: ${(props) => props.bg};
  }
  ${Cta} {
    background: black;
    color: white;
    padding: 10px 20px;
    border-radius: 2.5px;
    font-size: 16px;
  }
`

const ImageContent = styled.div<any>`
  z-index: 1;
  width: 100%;
  position: relative;
  aspect-ratio: unset;
  padding-bottom: 56.25%;
  @media ${breakpoint.desktop} {
    ${props => !props.themePage && css`
      margin-bottom: 70px;
    `}
    min-width: 895px;
    width: 60%;
    height: 524px;
    aspect-ratio: auto;
    padding-bottom: 0;
  }
`
